import { GenericDatabase } from './GenericDatabase'

const DB_NAME = 'Pautas'
const DB_VERSION = 1
const STORE_NAME = 'pautas'

const dbInstance = new GenericDatabase(DB_NAME, DB_VERSION, [
    { name: STORE_NAME, keyPath: '_id' }
])

const initDbPMs = () => {
    return dbInstance.init()
}

const agregar = (data, database) => {
    // Original returns {state: true/false, data: 'Ok'/e}. Mimic this.
    return dbInstance.add(STORE_NAME, data, database)
        .then(res => res ? { state: true, data: 'Ok' } : { state: false, data: 'Error' })
        .catch(e => ({ state: false, data: e }))
}

const obtener = (clave, database) => {
    return dbInstance.get(STORE_NAME, Number(clave), database)
}

const consultarPorDato = (dato, database) => {
    // Original was empty, just opened cursor and did nothing.
    // Return null as placeholder.
    return new Promise(resolve => resolve(null))
}

const actualizar = (data, database) => {
    // Original returns {state: true/false, data: 'Ok'/e}. Mimic this.
    return dbInstance.put(STORE_NAME, data, database)
        .then(res => res ? { state: true, data: 'Ok' } : { state: false, data: 'Error' })
        .catch(e => ({ state: false, data: e }))
}

const eliminar = (clave, database) => {
    // Original called consultar() on success, and logged result.
    // We will just delete.
    return dbInstance.delete(STORE_NAME, clave, database)
}

const borrarDb = () => {
    return dbInstance.deleteDatabase()
}

const consultar = (database) => {
    return dbInstance.getAll(STORE_NAME, database)
}

export default {
    initDbPMs,
    agregar,
    obtener,
    actualizar,
    eliminar,
    borrarDb,
    consultar,
    consultarPorDato
}
